import React, { useRef, useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import GroupsIcon from '@mui/icons-material/Groups';
import { useTranslation } from "react-i18next";

export function DialogRequestTeam(props) {
  const { openDialog, setOpenDialog, handleClickRequestInvitation, infoMemberTeam } = props;
  const { t } = useTranslation("global")
  
  const [ arr_teams_available, setArr_teams_available ] = useState([])
  const [ input_team_id_requested, setInput_team_id_requested ] = useState("")
  const [ completed, setCompleted ] = useState(false)

  useEffect(() => {
    // console.log("🚀 ~ file: DialogRequestTeam.js:22 ~ DialogRequestTeam ~ infoMemberTeam:", infoMemberTeam)
    if (infoMemberTeam['arr_teams_available'] !== undefined){
      setArr_teams_available(infoMemberTeam['arr_teams_available'])
    }
  }, [infoMemberTeam]);



  useEffect(() => {
    if (openDialog === false){
      setInput_team_id_requested("") 
    }
  }, [openDialog]);

  // useEffect(() => {
  //   console.log("🚀 ~ file: DialogRequestTeam.js:32 ~ DialogRequestTeam ~ arr_teams_available:", arr_teams_available)
  // }, [arr_teams_available]);    
  
  

  const handleChange = (e) => {
    setInput_team_id_requested(e.target.value)
  };

  useEffect(() => {
    if (input_team_id_requested !== "") {
      setCompleted(true)
    } else {
      setCompleted(false)
    }
  }, [input_team_id_requested]); 


  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleSendRequestTeam = () => {
    handleClickRequestInvitation(input_team_id_requested)
  };

  function handleChangeSelect(e){
    setInput_team_id_requested(e.target.value)
  }


  return (
    <Dialog className="sig_Drawer_SettingsModal_Root sig_BugReport_New_Root" open={openDialog} onClose={handleClose}>
      <DialogTitle className="sig_Drawer_SettingsModal_Title sig_Main_TitleWithIcon">
        {t("sRequestTeams.title")} <GroupsIcon />
      </DialogTitle>
      <DialogContent className="sig_Drawer_SettingsModal_Content sig_BugReport_New_Content">
        <p>{t("sRequestTeams.info").split('.').map((item, key) => {
          return <p key={key}>{item.trim()}</p>;
        })}</p>
        <hr />
        <div data-tour="tourBug_3" className="sig_BugReport_New_Info">
          <div className="sig_BugReport_New_InputContainer">
            <p className="sig_BugReport_New_Title_no_asterisk"> {t("sRequestTeams.identifier_team")} </p>
            <TextField              
              margin="dense"
              fullWidth
              InputProps={{ style: { padding: '10px' } }}
              onChange={(e) => handleChange(e)}
              value={input_team_id_requested}
              />
          </div>


          <div>
            <div className="sig_SignModal_PaperTitle"> {t("sTeams.show_public_teams")} </div>
          </div>
          <Select
            fullWidth
            className="sig_Teams_Select"
            size="small"
            onChange={(e) => handleChangeSelect(e)}
            >
              <MenuItem value="">
                <em>&nbsp;</em>
              </MenuItem>
              {arr_teams_available.map((usuario, index) => (
                <MenuItem key={index} value={usuario}>
                  <em>{usuario}</em>
                </MenuItem>
              ))}
          </Select>

        </div>
      </DialogContent>

      


      <DialogActions>
        <div>

          <Button className="sig_FormDialog_Button sig_FormDialog_Button_Send" onClick={handleSendRequestTeam} disabled={!completed}>
            {t("strButton.request").toUpperCase()}
          </Button>
          
          <Button className="sig_FormDialog_Button sig_FormDialog_Button_Cancel" onClick={handleClose}>
            {t("strButton.btn_cancel").toUpperCase()}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}
